var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.5 0C13.725 0 0 13.725 0 30.5S13.725 61 30.5 61 61 47.275 61 30.5 47.275 0 30.5 0zm-6.1 44.225v-27.45L42.7 30.5 24.4 44.225z","fill":"currentColor","fillRule":"nonzero"}));
}

Play.defaultProps = {"width":"61","height":"61"};

module.exports = Play;

Play.default = Play;
